import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { camelCase, snakeCase } from 'change-case'
// import { paths } from '../paths'

export const baseURL = process.env.API_URL || window.settings.API_URL

interface RecordValue {
  [key: string]: unknown
}

type DeepKeyMapper = (key: string) => string

function mapKeysDeep<T>(obj: T, fn: DeepKeyMapper): T {
  if (Array.isArray(obj)) {
    return obj.map((v) => mapKeysDeep(v, fn)) as T
  } else if (obj !== null && obj?.constructor === Object) {
    return Object.keys(obj as RecordValue).reduce((result, key) => {
      const value = (obj as RecordValue)[key]
      result[fn(key)] = mapKeysDeep(value, fn)
      return result
    }, {} as RecordValue) as T
  }
  return obj
}

const toSnakeCase = <T>(obj: T): T => mapKeysDeep(obj, (key) => snakeCase(key))

const toCamelCase = <T>(obj: T): T => mapKeysDeep(obj, (key) => camelCase(key))

export const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const axiosInstanceWithoutInterceptors = axios.create({
  baseURL,
  withCredentials: true,
})

export const setAccessToken = (accessToken: string) => {
  axiosInstance.defaults.headers.common['Authorization'] = accessToken
}

// const removeAccessToken = () => {
//   delete axiosInstance.defaults.headers.common['Authorization']
//   localStorage.removeItem('access_token')
// }

if (localStorage.getItem('access_token')) {
  setAccessToken(localStorage.getItem('access_token') || '')
}

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if (config.data) {
      config.data = toSnakeCase(config.data)
    }
    if (config.params) {
      config.params = toSnakeCase(config.params)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.data) {
      response.data = toCamelCase(response.data)
    }
    return response
  },
  async (error) => {
    if (error.response && error.response.data) {
      error.response.data = toCamelCase(error.response.data)
    }

    if (error.response.status === 401) {
      const refreshResponse = await axiosInstanceWithoutInterceptors.post<{ access_token: string; token_type: string }>(
        '/auth/refresh'
      )
      if (refreshResponse.status === 200) {
        localStorage.setItem('access_token', `${refreshResponse.data.token_type} ${refreshResponse.data.access_token}`)
        setAccessToken(`${refreshResponse.data.token_type} ${refreshResponse.data.access_token}`)
      }

      // removeAccessToken()
      // window.location.href = paths.login()
    }
    return Promise.reject(error)
  }
)
